import { FC, useState } from "react";
import "./Styles.css";
import Footer from "../../components/Footer";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import confetti from "canvas-confetti";
import toast from "react-hot-toast";
import { PAYPAL_CLIENT_ID, GIVING_PRESET_AMOUNTS } from "../../constants/giving";

const HomeComponent: FC<any> = ({ homePageData, error, isLoading }) => {
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [titheAmount, setTitheAmount] = useState<string>("");
  const [customAmount, setCustomAmount] = useState<string>("");
  const [showPaypalBtns, setShowPaypalBtns] = useState<boolean>(false);
  const [showThankYouModal, setShowThankYouModal] = useState<boolean>(false);
  
  console.log("homePageData", homePageData);
  console.log("error", error);
  console.log("isLoading", isLoading);

  const showConfetti = () => {
    const colors = ['#53a624', '#19369c', '#ffb703'];

    confetti({
      particleCount: 55,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colors,
    });
    confetti({
      particleCount: 55,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colors,
    });
  };

  const handleAmountSelect = (amount: string) => {
    setTitheAmount(amount);
    setCustomAmount("");
    setShowPaypalBtns(true);
  };

  const handleCustomAmountChange = (value: string) => {
    setCustomAmount(value);
    setTitheAmount("");
    setShowPaypalBtns(false);
  };

  const handleCustomAmountConfirm = () => {
    if (customAmount && parseFloat(customAmount) > 0) {
      setTitheAmount(customAmount);
      setShowPaypalBtns(true);
    }
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!homePageData) return <div>No data</div>;

  return (
    <div className="w-[100vw] min-h-[100vh]">
      <div className="relative flex flex-col md:flex-row h-auto md:h-[95vh] min-h-[100vh]">
        {homePageData?.bannerVids &&
          homePageData?.bannerVids.map((video: any, index: number) => (
            <div key={index} className="w-full h-[33.33vh] md:h-full">
              <video
                loop
                autoPlay
                muted
                className="w-full h-full object-cover"
                playsInline
                preload="auto"
              >
                <source src={video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 flex items-center justify-center w-full p-4 bg-transparent text-center">
          <img
            src={homePageData?.tccLogo}
            alt="Logo"
            className="h-16 mr-2 bg-transparent mobile:h-8"
          />
          <h1
            className="text-gray-200 bg-transparent text-sm font-light mobile:text-xs"
            style={{ letterSpacing: "1.1em", opacity: 0.4 }}
          >
            T R I N I T Y &nbsp; C H R I S T I A N &nbsp; C H U R C H
          </h1>
        </div>
        <div className="absolute inset-0 flex flex-col md:flex-row items-center justify-between">
          <div className="bg-tcc-blue bg-opacity-20 flex items-center justify-center w-full md:w-1/3 h-1/3 md:h-full px-4">
            <h1
              className="text-white text-6xl font-bold archivo-black-regular mobile:text-2xl text-center"
              style={{
                opacity: 0.9,
                letterSpacing: "0.15em",
                lineHeight: "1.2",
              }}
            >
              TRINITY
            </h1>
          </div>
          <div className="bg-tcc-green bg-opacity-20 flex items-center justify-center w-full md:w-1/3 h-1/3 md:h-full px-4">
            <h1
              className="text-white text-6xl archivo-black-regular mobile:text-2xl text-center"
              style={{
                opacity: 0.9,
                letterSpacing: "0.15em",
                lineHeight: "1.2",
              }}
            >
              CHRISTIAN
            </h1>
          </div>
          <div className="bg-tcc-brown bg-opacity-20 flex items-center justify-center w-full md:w-1/3 h-1/3 md:h-full px-4">
            <h1
              className="text-white text-6xl font-bold archivo-black-regular mobile:text-2xl text-center"
              style={{
                opacity: 0.9,
                letterSpacing: "0.15em",
                lineHeight: "1.2",
              }}
            >
              CHURCH
            </h1>
          </div>
        </div>
      </div>
      {/* About Section */}
      <div className="w-full py-24 px-8" style={{ backgroundColor: '#141414' }}>
        <div className="max-w-7xl mx-auto">
          <h2 className="text-5xl archivo-black-regular font-bold text-white mb-8 text-center mobile:text-3xl">
            About <i className="text-tcc-green anton-regular-italic">Us</i>
          </h2>
          
          {/* Declaration of Assurance */}
          <div className="bg-gradient-to-r from-tcc-blue/20 to-tcc-green/20 backdrop-blur-sm border border-tcc-blue/30 rounded-2xl p-8 md:p-12 mb-12 text-center">
            <h3 className="text-2xl md:text-3xl archivo-black-regular font-bold text-white mb-6">
              Declaration of <i className="text-tcc-green anton-regular-italic">Assurance</i>
            </h3>
            <p className="text-gray-200 text-lg md:text-xl leading-relaxed italic">
              "We are Trinity Christian Church. We are the body of Christ, we help people become whole in Christ, Body, Soul, and Spirit. We came to get the Word of God, experience the love of God and be touched by the Spirit of God. Amen."
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src={homePageData?.aboutImage}
                alt="Trinity Christian Church"
                className="rounded-lg shadow-2xl w-full h-auto object-cover"
              />
            </div>
            <div>
              <p className="text-gray-300 text-xl leading-relaxed mb-6">
                {homePageData?.aboutDescription || "Welcome to Trinity Christian Church, where faith meets community. We are a diverse congregation committed to spreading God's love and serving our community."}
              </p>
              <p className="text-gray-300 text-xl leading-relaxed mb-8">
                {homePageData?.aboutMission || "Our mission is to create a welcoming space where everyone can grow in their faith, build meaningful relationships, and make a positive impact in the world."}
              </p>
              <button className="bg-tcc-blue text-white px-10 py-4 rounded-lg font-semibold text-lg hover:bg-opacity-90 transition-all shadow-lg">
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>

          {/* Upcoming Events Section */}
      <div className="w-full py-16 px-8 md:px-16 lg:px-24 bg-white">
        <div className="mx-auto max-w-[1600px]">
          <div className="mb-12">
            <h2 className="text-5xl archivo-black-regular font-bold text-tcc-blue mb-4 mobile:text-3xl">
              Upcoming <i className="text-tcc-green anton-regular-italic">Events</i>
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl">
              Join us for inspiring gatherings, worship services, and community activities. 
              Stay connected and be part of something greater as we grow together in faith.
            </p>
          </div>
          <div className={`grid grid-cols-1 gap-6 px-4 ${
            homePageData?.events?.length === 1 ? 'md:grid-cols-1 max-w-md mx-auto' :
            homePageData?.events?.length === 2 ? 'md:grid-cols-2' :
            homePageData?.events?.length === 3 ? 'md:grid-cols-3' :
            homePageData?.events?.length === 4 ? 'md:grid-cols-4' :
            'md:grid-cols-3'
          }`}>
            {homePageData?.events?.map((event: any, index: number) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:scale-105 h-[550px] relative">
                <div className="absolute inset-0 bg-gradient-to-br from-tcc-blue to-tcc-green flex items-center justify-center">
                  {event.image ? (
                    <img
                      src={event.image}
                      alt={event.title}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full relative overflow-hidden bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer bg-[length:200%_100%]">
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="text-gray-400 text-6xl opacity-50">📅</div>
                      </div>
                    </div>
                  )}
                </div>
                {/* Overlay gradient for text readability - only at the bottom */}
                <div className="absolute bottom-0 left-0 right-0 h-64 bg-gradient-to-t from-black via-black/70 to-transparent"></div>
                
                {/* Content overlay at bottom */}
                <div className="absolute bottom-0 left-0 right-0 p-6 z-10 backdrop-blur-md bg-black/30">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-white font-bold text-xs bg-white bg-opacity-20 backdrop-blur-sm px-3 py-1 rounded-full">
                      {event.date}
                    </span>
                    <span className="text-tcc-green font-semibold text-xs bg-black bg-opacity-40 backdrop-blur-sm px-3 py-1 rounded-full">
                      {event.time}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2 archivo-black-regular">
                    {event.title}
                  </h3>
                  <p className="text-gray-200 text-xs leading-relaxed mb-3 line-clamp-2">
                    {event.description}
                  </p>
                  <button 
                    onClick={() => setSelectedEvent(event)}
                    className="w-full bg-white bg-opacity-20 backdrop-blur-sm text-white py-2 rounded-lg font-semibold hover:bg-opacity-30 transition-all border border-white border-opacity-30"
                  >
                    Learn More
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

       {/* Offering Section */}
      <div className="w-full py-16 px-8 bg-gradient-to-br from-tcc-blue to-tcc-green">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl archivo-black-regular font-bold text-white mb-6 mobile:text-2xl">
            Give <i className="anton-regular-italic">Online</i>
          </h2>
          <p className="text-white text-lg mb-8 opacity-90">
            Your generosity helps us continue our mission to serve the community and spread God's love. 
            Thank you for your faithful support and partnership in ministry.
          </p>
          <div className="mb-8 flex flex-wrap items-center justify-center gap-3">
            <a
              href="/giving"
              className="rounded-full bg-white px-6 py-3 font-semibold text-tcc-blue transition hover:bg-opacity-90"
            >
              Open Giving Page
            </a>
            <a
              href="/support"
              className="rounded-full border border-white/30 bg-white/10 px-6 py-3 font-semibold text-white transition hover:bg-white/15"
            >
              Need Donation Help?
            </a>
          </div>
          <div className="bg-white rounded-lg p-8 shadow-xl">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              {GIVING_PRESET_AMOUNTS.map((amount, index) => (
                <button
                  key={amount}
                  onClick={() => handleAmountSelect(amount)}
                  className={`text-center p-4 rounded-lg border-2 transition-all ${
                    titheAmount === amount
                      ? index === 0
                        ? "border-tcc-blue bg-tcc-blue bg-opacity-10"
                        : "border-tcc-green bg-tcc-green bg-opacity-10"
                      : index === 0
                        ? "border-gray-200 hover:border-tcc-blue"
                        : "border-gray-200 hover:border-tcc-green"
                  }`}
                >
                  <div
                    className={`text-3xl font-bold mb-2 ${
                      index === 0 ? "text-tcc-blue" : "text-tcc-green"
                    }`}
                  >
                    ${amount}
                  </div>
                  <div className="text-gray-600 text-sm">One-Time Gift</div>
                </button>
              ))}
              <div className="text-center p-4 rounded-lg border-2 border-gray-200">
                <div className="text-3xl font-bold text-tcc-brown mb-2">Custom</div>
                <input
                  type="number"
                  placeholder="Enter amount"
                  value={customAmount}
                  onChange={(e) => handleCustomAmountChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleCustomAmountConfirm();
                    }
                  }}
                  className="w-full mt-2 px-3 py-2 border border-gray-300 rounded-lg text-center focus:outline-none focus:border-tcc-brown"
                />
                {customAmount && (
                  <button
                    onClick={handleCustomAmountConfirm}
                    className="w-full mt-2 bg-tcc-brown text-white py-2 px-4 rounded-lg font-semibold hover:bg-opacity-90 transition-all text-sm"
                  >
                    Confirm ${customAmount}
                  </button>
                )}
              </div>
            </div>
            
            {showPaypalBtns && titheAmount && (
              <PayPalScriptProvider
                options={{
                  clientId: PAYPAL_CLIENT_ID,
                  currency: "USD",
                }}
              >
                <div className="max-w-md mx-auto mb-4">
                  <PayPalButtons
                    style={{
                      layout: "vertical",
                      label: "paypal",
                    }}
                    createOrder={(data, actions) => {
                      return actions.order.create({
                        intent: "CAPTURE",
                        purchase_units: [
                          {
                            amount: {
                              currency_code: "USD",
                              value: titheAmount,
                            },
                          },
                        ],
                      });
                    }}
                    onApprove={(data, actions) => {
                      return actions.order!.capture().then((details) => {
                        showConfetti();
                        setShowThankYouModal(true);
                        setTitheAmount("");
                        setShowPaypalBtns(false);
                      });
                    }}
                    onError={(err) => {
                      console.error("PayPal Error:", err);
                      toast.error("Payment failed. Please try again.");
                    }}
                    onCancel={() => {
                      setTitheAmount("");
                      setShowPaypalBtns(false);
                      toast("Payment cancelled");
                    }}
                  />
                </div>
              </PayPalScriptProvider>
            )}
            
            <p className="text-gray-500 text-sm mt-6">
              All donations are tax-deductible. You will receive a receipt via email.
            </p>
          </div>
        </div>
      </div>

      {/* Sermons Section */}
      {homePageData?.sermons && homePageData.sermons.length > 0 && (
        <div className="w-full py-16 px-8 bg-white">
          <div className="mx-auto max-w-[1800px]">
            <h2 className="text-4xl archivo-black-regular font-bold text-tcc-blue mb-8 text-center mobile:text-2xl">
              Recent <i className="text-tcc-green anton-regular-italic">Sermons</i>
            </h2>
            <div className={`grid grid-cols-1 gap-6 px-4 ${
              homePageData?.sermons?.length === 1 ? 'md:grid-cols-1 max-w-2xl mx-auto' :
              homePageData?.sermons?.length === 2 ? 'md:grid-cols-2' :
              homePageData?.sermons?.length >= 3 ? 'md:grid-cols-3' :
              'md:grid-cols-3'
            }`}>
              {homePageData?.sermons?.map((sermon: any, index: number) => (
                <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:scale-105">
                  <div className="relative w-full aspect-video bg-gradient-to-br from-tcc-blue to-tcc-green flex items-center justify-center">
                    {sermon.thumbnail ? (
                      <img
                        src={sermon.thumbnail}
                        alt={sermon.title}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-tcc-blue bg-opacity-10">
                        <span className="text-white text-8xl opacity-50">▶</span>
                      </div>
                    )}
                  </div>
                  
                  {/* Content below image */}
                  <div className="p-4 bg-white">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-tcc-green font-semibold text-xs bg-tcc-green bg-opacity-10 px-3 py-1 rounded-full">
                        {sermon.date}
                      </span>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1 archivo-black-regular line-clamp-1">
                      {sermon.title}
                    </h3>
                    <p className="text-gray-600 text-xs mb-3">
                      {sermon.speaker}
                    </p>
                    {sermon.videoUrl ? (
                      <a
                        href={sermon.videoUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block w-full bg-tcc-blue text-white py-2 rounded-lg font-semibold hover:bg-opacity-90 transition-all text-center"
                      >
                        Watch Sermon
                      </a>
                    ) : (
                      <button disabled className="w-full bg-gray-300 text-gray-500 py-2 rounded-lg font-semibold cursor-not-allowed">
                        Watch Sermon
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

     

      {/* Footer */}
      <Footer homePageData={homePageData} />

      {/* Event Modal Overlay */}
      {selectedEvent && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
          onClick={() => setSelectedEvent(null)}
        >
          <div 
            className="bg-white rounded-2xl overflow-hidden shadow-2xl max-w-5xl w-full max-h-[90vh] flex flex-col md:flex-row"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Image/Flyer Section */}
            <div className="md:w-1/2 h-64 md:h-auto relative bg-gradient-to-br from-tcc-blue to-tcc-green">
              {selectedEvent.image ? (
                <img
                  src={selectedEvent.image}
                  alt={selectedEvent.title}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <div className="text-white text-8xl opacity-50">📅</div>
                </div>
              )}
            </div>

            {/* Info Section */}
            <div className="md:w-1/2 p-8 md:p-12 overflow-y-auto">
              <button
                onClick={() => setSelectedEvent(null)}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-3xl font-bold transition-colors"
                aria-label="Close"
              >
                ×
              </button>

              <div className="mb-6">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-tcc-blue font-bold text-sm bg-tcc-blue bg-opacity-10 px-4 py-2 rounded-full">
                    {selectedEvent.date}
                  </span>
                  <span className="text-tcc-green font-semibold text-sm bg-tcc-green bg-opacity-10 px-4 py-2 rounded-full">
                    {selectedEvent.time}
                  </span>
                </div>

                <h3 className="text-4xl font-bold text-gray-900 mb-4 archivo-black-regular">
                  {selectedEvent.title}
                </h3>

                <p className="text-gray-700 text-lg leading-relaxed mb-6">
                  {selectedEvent.description}
                </p>

                {selectedEvent.location && (
                  <div className="mb-4">
                    <h4 className="text-tcc-blue font-semibold text-sm mb-1">LOCATION</h4>
                    <p className="text-gray-700">{selectedEvent.location}</p>
                  </div>
                )}

                {selectedEvent.details && (
                  <div className="mb-4">
                    <h4 className="text-tcc-blue font-semibold text-sm mb-1">DETAILS</h4>
                    <p className="text-gray-700">{selectedEvent.details}</p>
                  </div>
                )}
              </div>

              <div className="flex gap-4">
                {/* <button className="flex-1 bg-tcc-blue text-white py-3 px-6 rounded-lg font-semibold hover:bg-opacity-90 transition-all shadow-md">
                  Register Now
                </button> */}
                <button 
                  onClick={() => setSelectedEvent(null)}
                  className="flex-1 bg-gray-200 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-300 transition-all"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Thank You Modal */}
      {showThankYouModal && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
          onClick={() => setShowThankYouModal(false)}
        >
          <div 
            className="bg-white rounded-2xl overflow-hidden shadow-2xl max-w-md w-full p-8 text-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-6">
              <div className="text-6xl mb-4">🙏</div>
              <h2 className="text-3xl font-bold text-tcc-blue mb-4 archivo-black-regular">
                Thank You!
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-2">
                Thank you so much for your generous contribution!
              </p>
              <p className="text-gray-600 text-sm">
                Your support helps us continue our mission to serve the community and spread God's love.
              </p>
            </div>
            
            <div className="bg-gradient-to-r from-tcc-blue/10 to-tcc-green/10 rounded-lg p-4 mb-6">
              <p className="text-gray-700 text-sm">
                A receipt has been sent to your email.
              </p>
            </div>

            <button 
              onClick={() => setShowThankYouModal(false)}
              className="w-full bg-tcc-blue text-white py-3 px-6 rounded-lg font-semibold hover:bg-opacity-90 transition-all shadow-md"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeComponent;
